import React, { useEffect, useState, useContext } from 'react';
import styles from 'routes/vendorRe/pages/VendorInfo.module.css';
import Container from 'routes/vendorRe/containers/commons/Container';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import depthMove from 'routes/vendorRe/images/depth_move_icon.png';
import {
    contentStart,
    contentEnd,
    infoFontSize1,
    infoFontSize2,
    commonFontWeight700,
    commonBgColor,
    infoFontColor1,
    infoFontColor2,
    commonH1Size,
    commonH1Padding,
    infoFontColor3,
    infoBorderColor,
    infoFontColor4,
    commonBodyPadding,
    commonBodyPadding2,
    infoEm,
    statsOuterPadding,
    statsPaddingStart,
    statsPaddingMiddle,
    statsPaddingEnd,
} from 'routes/vendorRe/constraint/constraints';
import { requester } from 'App';
import VendorInfoList from 'routes/vendorRe/components/VendorInfoList';
import {
    combineDuplicates,
    filterDataByThisMonth,
    filterDataByThisWeek,
    filterDataByThisYear,
    filterDataByToday,
    getTotalAmount
} from 'routes/vendorRe/commonFn/vendorPurchaseOrder';
import { AuthContext } from 'providers/AuthProvider';
import { useNavigate } from 'react-router-dom';

const VendorInfo = () => {
    const { userName } = useContext(AuthContext);
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.toLocaleString('ko-KR', { month: 'long' });
    const [isMounted, setMounted] = useState(false);
    const [totalAmount, setTotalAmount] = useState({});
    const [stores, setStores] = useState();
    const navigate = useNavigate();
    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            requester.getVendorSettlementFee((result) => {
                setTotalAmount(result.data)
            })
            requester.findAllVendorStore((result) => {
                setStores(result.data);
            })
        }

    }, [isMounted])
    const onSalesClick = () => {
        navigate("/vendor/main/calc");
    }


    return (
        <Container backgroundColor={commonBgColor} height={"90vh"}>
            <div style={{height: "10vh"}}></div>
            <VerticalFlex backgroundColor={commonBgColor}>
                <FlexChild padding={commonBodyPadding2} >
                    <VerticalFlex>
                        <FlexChild alignItems={contentStart}>
                            <P padding={commonH1Padding} size={commonH1Size}>{userName && userName} 님</P>
                            <VerticalFlex backgroundColor="white" borderRadius={infoEm} padding={statsOuterPadding}>
                                <FlexChild padding={statsPaddingStart}>
                                    <HorizontalFlex>
                                        <FlexChild flex="12">
                                            <P weight={commonFontWeight700} size={infoFontSize1} padding="0 1em 0 0">정산 예정 금액</P>
                                            <P size={infoFontSize2} color={infoFontColor4}>( {currentYear}년 {currentMonth} 기준 )</P>
                                        </FlexChild>
                                        <FlexChild flex="1" justifyContent={contentEnd}>
                                            <img onClick={onSalesClick} width={"30px"} className={styles.depthMove} src={depthMove} alt='뎁스 이동' />
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <div className={styles.borderTop}>
                                        <VerticalFlex>
                                            <FlexChild padding={statsPaddingMiddle} borderTop={infoBorderColor}>
                                                <HorizontalFlex>
                                                    <FlexChild >
                                                        <P size={infoFontSize1} color={infoFontColor1}>이달 매출</P>
                                                    </FlexChild>
                                                    <FlexChild justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor1}>{totalAmount && totalAmount.totalPrice ? totalAmount.totalPrice.toLocaleString() : 0}</P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild padding={statsPaddingMiddle}>
                                                <HorizontalFlex>
                                                    <FlexChild >
                                                        <P size={infoFontSize1} color={infoFontColor1}>물품 대금</P>
                                                    </FlexChild>
                                                    <FlexChild justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor1}>
                                                            {totalAmount && totalAmount.totalsupplyPrice ? (`- `) + totalAmount.totalsupplyPrice.toLocaleString() : 0}
                                                        </P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild padding={statsPaddingEnd}>
                                                <HorizontalFlex>
                                                    <FlexChild flex="3">
                                                        <P size={infoFontSize1} color={infoFontColor3}>이번달 정산예정 금액</P>
                                                    </FlexChild>
                                                    <FlexChild flex="1" justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor2}>{totalAmount && totalAmount.totalAmount ? totalAmount.totalAmount.toLocaleString() : 0}</P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </div>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
                <FlexChild padding={commonBodyPadding} backgroundColor={commonBgColor}>
                    <VerticalFlex>
                        <FlexChild justifyContent={contentStart} alignItems={contentStart}>
                            <P padding={commonH1Padding} size={commonH1Size}>매장 상태 확인</P>
                            <VerticalFlex>
                                <FlexChild>
                                    <div className={styles.scrollCover}>
                                        <VerticalFlex flexStart gap={20}>
                                            {
                                                stores &&
                                                stores.map((data, index) => {
                                                    return (
                                                        <VendorInfoList data={data} />
                                                    );
                                                })
                                            }
                                        </VerticalFlex>
                                    </div>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default VendorInfo;